module.exports = __webpack_public_path__ + "img/haitun1.1610e43d.png";